module.exports = __webpack_public_path__ + "media/images/clipboard-d0c6803de67b864f5216815d54ab27da.svg";